import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { FlexModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyTotalModule } from '@app/shared/components/ui';
import { TaxDropdownModule } from '@app/shared/components/form-fields/dropdowns';

import { ExpensesEditableGridComponent } from './expenses-editable-grid.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ExpensesEditableGridComponent],
  imports: [
    CommonModule,
    FlexModule,
    ButtonModule,
    GridModule,
    ComboBoxModule,
    NumericTextBoxModule,
    FormsModule,
    ReactiveFormsModule,

    CurrencyTotalModule,
    TaxDropdownModule,
    TranslateModule
  ],
  exports: [ExpensesEditableGridComponent, TranslateModule]
})
export class ExpensesEditableGridModule {}
